import { useLayoutEffect } from "react";
const useFakeFunction = () => {
    return true;
};
export const useBrowserLayoutEffect =
    typeof window !== "undefined" ? useLayoutEffect : useFakeFunction;

export default useBrowserLayoutEffect;
